import React, { useEffect, useState } from "react";
import { YardDateField } from "../../../components/common/YardDateField";
import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";

import {
  Card,
  Divider,
  makeStyles,
  Tab,
  Tabs,
  useMediaQuery,
} from "@material-ui/core";

import {
  Datagrid,
  DateInput,
  downloadCSV,
  EditButton,
  FilterButton,
  ListContextProvider,
  ListToolbar,
  RefreshButton,
  SimpleList,
  ShowButton,
  TextField,
  Title,
  TopToolbar,
  useListContext,
  FunctionField,
} from "react-admin";

import { ChevronRightIcon } from "../../../components/common/iconography";
import ShipsTogetherBadge from "../../../components/common/shipWith/ShipsTogetherBadge";
import ExportButton from "../../../components/common/ExportButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { SearchField } from "../../../components/common/SearchField";
import { useSearchableList } from "../../../dataProvider/useSearchableList";
import {
  MAX_INVENTORY_QUERY_LIMIT,
  OutboundStatus,
} from "../../../utils/constants";
import {
  exportCustomField,
  normalizeValue,
  truncateText,
} from "../../../utils/utils";
import { useUser } from "../../../authenticatorApp/UserContext";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
}));

const tabs = [
  {
    id: OutboundStatus.PENDING,
    name: "PENDING",
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.ARRIVED,
    name: "ARRIVED",
    sortKey: "arrivalDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.PLACED,
    name: "PLACED",
    // placementDateTime is not in the by-dates GSI; arrivalDateTime is, and
    // placing backfills it when unset, so it approximates placed order.
    sortKey: "arrivalDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.LOADED,
    name: "LOADED",
    sortKey: "endDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.RELEASED,
    name: "DEPARTED",
    sortKey: "endDateTime",
    sortOrder: "DESC",
    showSmall: false,
  },
];

const getVisibleTabs = (lteMedium) => {
  return tabs.filter((tab) => !lteMedium || tab.showSmall);
};

// The PENDING tab is the carrier's dispatch queue: rows open the form that
// schedules or reschedules the pickup, the same role the Deliveries list gives
// its IN_TRANSIT tab. Every later tab is a record of what already happened, and
// stays read-only.
const getRowClickAction = (tabValue) =>
  tabValue === OutboundStatus.PENDING ? "edit" : "show";

// Routed through getRowClickAction so the button can never offer something the
// row click doesn't.
const renderActionButtons = (tabValue, record) =>
  getRowClickAction(tabValue) === "edit" ? (
    <EditButton record={record} />
  ) : (
    <ShowButton record={record} />
  );

// Leads every tab (AD-12): a group persists through Arrived, Placed, Loaded
// and Departed, and a departed group still reads as one truck. Renders
// nothing for a load that ships alone, so those rows look as they did.
const renderShipsTogether = (record) => (
  <ShipsTogetherBadge record={record} selfId={record.id} size="small" />
);

const exporter = (outbounds) => {
  const customHeaderMap = new Map();
  debugger;
  const outboundsForExport = outbounds.map((outbound) => {
    const outboundForExport = { ...outbound };

    if (outbound.shipmentLineItems.items) {
      outboundForExport.pickList = [];

      outbound.shipmentLineItems.items.forEach((lineItem) => {
        lineItem.inventoryItems.items.forEach((inventoryItem) => {
          const exportlineItem = {
            inventoryId: lineItem.inventoryId,
            productCode: lineItem.inventory.productCode,
            productName: lineItem.inventory.productName,
            lotNumber: lineItem.lotNumber,
            quantityOutbound: lineItem.totalQuantityToPick,
            units: outbound.totalUOM,
            location: inventoryItem.inventoryItem.locationFullName,
            quantityOnHand: inventoryItem.inventoryItem.quantityOnHand,
          };

          outboundForExport.pickList.push(exportlineItem);
        });
      });
    }
    delete outboundForExport.shipmentLineItems;

    if (outbound.customFields?.length > 0) {
      debugger;
      outbound.customFields.forEach((field) => {
        exportCustomField(field, outboundForExport, customHeaderMap);
      });
    }
    delete outboundForExport.customFields;

    delete outboundForExport.account;
    delete outboundForExport.assignedTo;
    delete outboundForExport.bolFile;
    delete outboundForExport.createdAt;
    delete outboundForExport.createDateTime;
    delete outboundForExport.daysOnDemurrageClock;
    delete outboundForExport.didTarp;
    delete outboundForExport.endDateTime;
    delete outboundForExport.history;
    delete outboundForExport.invoiceId;
    delete outboundForExport.mustTarp;
    delete outboundForExport.reloadYardId;
    delete outboundForExport.startDateTime;
    delete outboundForExport.updatedAt;

    return outboundForExport;
  });

  jsonExport(
    fillDownRows(outboundsForExport),
    { rename: ["outboundShipmentId"] },
    (err, csv) => {
      downloadCSV(csv, `outboundShipments_${new Date().toLocaleDateString()}`); // download as 'outboundShipments.csv` file
    },
  );
};

const OutboundSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const normalizedValue = normalizeValue(value);
      delete filterValues.or;
      setFilters(
        {
          ...filterValues,
          or: [
            { bolNumber: { matchPhrasePrefix: `${value}` } },
            { bolNumber: { wildcard: `*${value}*` } },
            // {
            //   normalizedPickupNumber: {
            //     matchPhrasePrefix: `${normalizedValue}`,
            //   },
            // },
            // { normalizedPoNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            // {
            //   normalizedConsigneePoNumber: {
            //     matchPhrasePrefix: `${normalizedValue}`,
            //   },
            // },
            // { normalizedRailCarNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            { normalizedPickupNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            {
              normalizedConsigneePoNumber: { wildcard: `*${normalizedValue}*` },
            },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      delete filterValues.or;
      setFilters(filterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (visibleTabs, tabIndex) => {
  const filters = [<OutboundSearchField label="Search" alwaysOn />];

  if (visibleTabs[tabIndex].id === OutboundStatus.RELEASED) {
    filters.push(
      <DateInput
        source="departureDateTime.lte"
        label="Shipped Before..."
        variant="outlined"
        resettable
        onKeyPress={(event) => event.preventDefault()}
      />,
      <DateInput
        source="departureDateTime.gte"
        label="Shipped After..."
        variant="outlined"
        resettable
        onKeyPress={(event) => event.preventDefault()}
      />,
    );
  }
  return filters;
};

const ListActions = (props) => {
  const { isXSmall } = props;
  const { resource, total } = useListContext();

  return !isXSmall ? (
    <TopToolbar>
      <FilterButton />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        exporter={exporter}
        perPage={MAX_INVENTORY_QUERY_LIMIT}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSortOrder = (visibleTabs, tabIndex) => {
  return visibleTabs[tabIndex].sortOrder;
};

const getSortBy = (visibleTabs, tabValue) => {
  const tabIndex = visibleTabs.findIndex((tab) => tab.id === tabValue);
  return `{"key":"outboundShipmentByCarrierByStatusByDates", "search":"${visibleTabs[tabIndex].sortKey}"}`;
};

// The tab's status id is persisted rather than its index: the index shifts
// whenever the tab list changes shape — a tab added or removed, or the small
// -screen filter dropping the ones with showSmall false — and a stale index
// would silently restore a different tab than the one the user left on.
const getSessionTab = (visibleTabs, appUser) => {
  const sessionTabId = sessionStorage.getItem(`OutboundTab_${appUser.id}`);
  const sessionTab = visibleTabs.findIndex((tab) => tab.id === sessionTabId);
  return sessionTab === -1 ? 0 : sessionTab; // Default to the first visible tab
};

export const OutboundList = (props) => {
  const { appUser } = useUser();
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const lteMedium = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [visibleTabs, setVisibleTabs] = useState(getVisibleTabs(lteMedium));
  const [tabIndex, setTabIndex] = useState(getSessionTab(visibleTabs, appUser));

  const [defaultFilter, setDefaultFilter] = useState({
    carrierId: appUser.carrierId,
    statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: {
      beginsWith: {
        status: visibleTabs[tabIndex].id,
      },
    },
  });
  const [defaultSearchFilter, setDefaultSearchFilter] = useState({
    reloadYardId: { eq: appUser?.reloadYardId },
    carrierId: { eq: appUser.carrierId },
    status: { matchPhrasePrefix: visibleTabs[tabIndex].id },
  });
  const defaultSort = {
    field: getSortBy(visibleTabs, visibleTabs[tabIndex].id),
    order: getSortOrder(visibleTabs, tabIndex),
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Pickups",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "outboundShipments",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listContext?.filter]);

  useEffect(() => {
    setVisibleTabs(getVisibleTabs(lteMedium));
  }, [lteMedium]);

  const handleTabChange = (value) => {
    debugger;
    setTabIndex(value);
    setDefaultFilter({
      carrierId: appUser.carrierId,
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: {
        beginsWith: {
          status: visibleTabs[value].id,
        },
      },
    });
    setDefaultSearchFilter({
      reloadYardId: { eq: appUser?.reloadYardId },
      carrierId: { eq: appUser.carrierId },
      status: { eq: visibleTabs[value].id },
    });
    listContext.setSort(
      getSortBy(visibleTabs, visibleTabs[value].id),
      getSortOrder(visibleTabs, value),
    );
    listContext.setPage(1);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Pickups" />} />
      <ListToolbar
        {...props}
        filters={getListFilters(visibleTabs, tabIndex)}
        actions={<ListActions isXSmall={isXSmall} />}
      />
      <Card className={classes.listRoot}>
        <ShipmentTabs
          {...props}
          {...listContext}
          appUser={appUser}
          visibleTabs={visibleTabs}
          tabIndex={tabIndex}
          setTabIndex={handleTabChange}
          isXSmall={isXSmall}
          lteMedium={lteMedium}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const ShipmentTabs = ({ tabIndex, setTabIndex, setPage, ...props }) => {
  const { visibleTabs, appUser } = props;

  const handleChange = (event, value) => {
    const adjustedValue = visibleTabs[value] ? value : 0; // Adjust tab index to the first visible tab if needed
    sessionStorage.setItem(
      `OutboundTab_${appUser.id}`,
      visibleTabs[adjustedValue].id,
    );
    setTabIndex(adjustedValue);
  };

  return (
    <>
      <Tabs
        value={Number(tabIndex)}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {visibleTabs.map((tab, idx) => (
          <Tab key={tab.id} label={tab.name} id={`shipment-${idx}`} />
        ))}
      </Tabs>
      <Divider />
      {visibleTabs.map(
        (tab) =>
          tab.id === visibleTabs[tabIndex].id && (
            <ShipmentGrid {...props} key={tab.id} tabValue={tab.id} />
          ),
      )}
    </>
  );
};

const ShipmentGrid = ({ ids, page, visibleTabs, tabValue, ...props }) => {
  const { isXSmall, lteMedium } = props;

  return isXSmall ? (
    <SimpleList
      linkType={getRowClickAction(tabValue)}
      primaryText={(record) => record.accountName}
      secondaryText={(record) => `Pickup No: ${record.pickupNumber}`}
      tertiaryText={(record) =>
        record.assignedTo ? truncateText(record.assignedTo, 12) : null
      }
      leftIcon={(record) => <ShipsTogetherBadge record={record} compact />}
      rightIcon={() => (
        <ChevronRightIcon
          fontSize="large"
          color="secondary"
          style={{ marginLeft: 40, marginTop: 10 }}
        />
      )}
    />
  ) : lteMedium ? (
    <Datagrid rowClick={getRowClickAction(tabValue)}>
      <FunctionField
        source="shipWithIds"
        label=" "
        sortable={false}
        render={renderShipsTogether}
      />
      <TextField source="poNumber" label="PO Number" sortable={true} />
      <TextField source="pickupNumber" label="Pickup No." sortable={true} />
      <TextField source="carrierName" label="Carrier Name" sortable={true} />
      {tabValue === OutboundStatus.PENDING ? (
        <YardDateField
          source="scheduledDateTime"
          label="Scheduled Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.ARRIVED ? (
        <YardDateField
          source="arrivalDateTime"
          label="Arrival Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.PLACED ? (
        <YardDateField
          source="placementDateTime"
          fallbackSource="arrivalDateTime"
          label="Placed Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.LOADED ? (
        <YardDateField
          source="endDateTime"
          label="Loaded Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.RELEASED ? (
        <YardDateField
          source="departureDateTime"
          label="Ship Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
    </Datagrid>
  ) : (
    <Datagrid rowClick={getRowClickAction(tabValue)} hasBulkActions={false}>
      <FunctionField
        source="shipWithIds"
        label=" "
        sortable={false}
        render={renderShipsTogether}
      />
      <TextField source="poNumber" label="PO Number" sortable={true} />
      <TextField source="pickupNumber" label="Pickup No." sortable={true} />
      <TextField source="carrierName" label="Carrier Name" sortable={true} />
      {tabValue === OutboundStatus.PENDING ? (
        <YardDateField
          source="scheduledDateTime"
          label="Scheduled Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.ARRIVED ? (
        <YardDateField
          source="arrivalDateTime"
          label="Arrival Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.PLACED ? (
        <YardDateField
          source="placementDateTime"
          fallbackSource="arrivalDateTime"
          label="Placed Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.LOADED ? (
        <YardDateField
          source="endDateTime"
          label="Loaded Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.RELEASED ? (
        <YardDateField
          source="departureDateTime"
          label="Ship Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.RELEASED ? (
        <TextField source="bolNumber" label="BOL Number" sortable={true} />
      ) : null}
      <FunctionField
        render={(record) => renderActionButtons(tabValue, record)}
      />
    </Datagrid>
  );
};
